import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ExpandedContent,
  ExpandedContentService,
} from '../../services/expanded-content.service';
import { Subscription } from 'rxjs';
import { ReadAloudService } from 'src/app/modules/read-aloud/services';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { PopupService } from 'src/app/shared/services/popup/popup.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LexicalTableModule } from 'src/app/modules/lexical-table/lexical-table.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChartComponent } from 'src/app/modules/chart/chart.component';

@Component({
  selector: 'htc-expandable-modal',
  standalone: true,
  imports: [
    LexicalTableModule,
    SharedModule,
    NgxSkeletonLoaderModule,
    ChartComponent,
  ],
  templateUrl: `./expandable-modal.component.html`,
  styleUrl: './expandable-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableModalComponent implements AfterViewInit, OnDestroy {
  @Input() expandableContent!: ExpandedContent;
  @Output() closedEvent = new EventEmitter();
  @ViewChild(DialogComponent, { static: true }) dialog!: DialogComponent;

  loaded = false;
  sub = new Subscription();

  constructor(
    private expandedContentService: ExpandedContentService,
    public popupService: PopupService,
    public readAloudService: ReadAloudService,
    public changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.sub.add(
      this.expandedContentService.getExpandedContent().subscribe(ec => {
        this.expandableContent = ec;
      })
    );

    this.sub.add(
      this.expandedContentService.isOpen().subscribe(isOpen => {
        if (isOpen) {
          this.openModal();
        }
      })
    );
  }

  openModal(): void {
    if (this.dialog) {
      this.dialog.open();
      this.readAloudService.stopCurrent();
    }
  }

  onPopupChange(): void {
    if (!this.dialog.isOpen) {
      this.expandedContentService.close();
      this.popupService.focusActiveElement();
    }
  }

  onLoaded(): void {
    this.loaded = true;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
